import React from "react";
import Tenants from "../../Components/OrganizationSettings/TenantManagement/Tenants";
import { TenantProvider } from "../../Context/Tenant/TenantContext";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

const WorkspaceOrganizationTenantUsersPage = ({ role }) => {
    const authorized = role.roleType === 'Owner' || role.roleType === 'Administrator';
    if (!authorized) {
        return <NoAccessComponent />
    }
    return (
        <TenantProvider>
            <Tenants />
        </TenantProvider>
    );
};

export default WorkspaceOrganizationTenantUsersPage; 